<div class="container contentHeight">
  <mat-horizontal-stepper linear #stepper class="container-fluid backgroundWhiteRound">
    <mat-step [stepControl]="rentingForm">
      <form>
        <ng-template matStepLabel> <span class="respLabel" [translate]="'renting.customerId'"></span></ng-template>
        <h1 class="text-center" [translate]="'renting.customerId'"></h1>
        <hr class="col-10 mx-auto">
        <div class="row">
          <div class="col-lg-6 col-sm-12">
            <h3> <i  aria-hidden="true" class="fal fa-industry-alt fa-1-2x titleIcon"></i> <span [translate]="'register.companyInfo'"> </span>  </h3>
            <div [formGroup]="companyForm" class="row">
              <mat-form-field class="col-lg-6 col-sm-12">
                <mat-label>{{'scaleform.raisonsociale'|translate}}</mat-label>
                <input matInput formControlName="socialReason" required>
              </mat-form-field>
              <mat-form-field class="col-lg-6 col-sm-12">
                <mat-label>{{'scaleform.adresse'|translate}}</mat-label>
                <input matInput formControlName="address" required>
              </mat-form-field>
              <mat-form-field class="col-lg-6 col-sm-12">
                <mat-label>{{'scaleform.codepostal'|translate}}</mat-label>
                <input matInput formControlName="postalCode" required>
              </mat-form-field>
              <mat-form-field class="col-lg-6 col-sm-12">
                <mat-label>{{'scaleform.ville'|translate}}</mat-label>
                <input matInput formControlName="city" required>
              </mat-form-field>
              <mat-form-field class="col-lg-6 col-sm-12">
                <mat-label>{{'scaleform.pays'|translate}}</mat-label>
                <mat-select formControlName="country" (selectionChange)="updateCountry($event)" required>
                  <mat-option *ngFor="let country of countries" value="{{country.name}}"> {{country.txt|translate}} </mat-option>
                </mat-select>
              </mat-form-field>
              <!-- <mat-form-field class="col-lg-6 col-sm-12">
                  <mat-label>{'scaleform.pays'|translate}}</mat-label>
                  <input matInput formControlName="country" >
              </mat-form-field> -->
              <mat-form-field class="col-lg-6 col-sm-12">
                <mat-label>{{'renting.siren'|translate}}</mat-label>
                <input matInput formControlName="siren">
              </mat-form-field>

              <mat-form-field class="col-lg-6 col-sm-12" *ngIf="tvaCkeck">
                <mat-label>{{'scaleform.tva'|translate}}</mat-label>
                <input matInput type="text" formControlName="tva" oninput="this.value = this.value.toUpperCase()" (ngModelChange)="checkTvaIntra()" />
                <mat-error>{{'shoppingcart.invalidTva'|translate}}</mat-error>
              </mat-form-field>

            </div>
          </div>
          <div class="col-lg-6 col-sm-12">
            <h3> <i  aria-hidden="true" class="fal fa-address-card fa-1-2x titleIcon"></i> <span [translate]="'renting.societyContact'"></span></h3>
            <div [formGroup]="rentingForm" class="row">
              <mat-form-field class="col-lg-6 col-sm-12">
                <mat-label>{{'renting.leader'|translate}}</mat-label>
                <input matInput formControlName="leader" required>
              </mat-form-field>
              <mat-form-field class="col-lg-6 col-sm-12">
                <mat-label>{{'renting.bodyshopInterlocutor'|translate}}</mat-label>
                <input matInput formControlName="bodyshopInterlocutor" required>
              </mat-form-field>
              <mat-form-field class="col-lg-6 col-sm-12">
                <mat-label>{{'scaleform.telephone'|translate}}</mat-label>
                <input matInput formControlName="companyDirectLign" required>
              </mat-form-field>
              <mat-form-field class="col-lg-6 col-sm-12">
                <mat-label>{{'renting.mailclient'|translate}}</mat-label>
                <input matInput formControlName="companyMail" required>
              </mat-form-field>
              <mat-form-field class="col-lg-6 col-sm-12">
                <mat-label>{{'scaleform.mobile'|translate}}</mat-label>
                <input matInput formControlName="companyPhone">
              </mat-form-field>
            </div>
          </div>
          <h3 class="col-12"> <i  aria-hidden="true" class="fal fa-id-card-alt fa-1-2x titleIcon"></i> <span [translate]="'renting.customerActivity'"></span></h3>
          <div [formGroup]="rentingForm" class="col-lg-6 col-sm-12">
            <mat-radio-group class="row" [(ngModel)]="selection" formControlName="companyType">
              <span class="mb-2 font-weight-bold col-lg-4 col-sm-6" id="companyType" [translate]="'renting.companyType'"></span>
              <ul class="col-lg-8 col-sm-6" (click)="removeCheckboxError('companyType')">
                <li class="row">
                  <mat-radio-button class="mt-2 col-lg-6 col-sm-6 reseauCheckbox" value="reseau" (change)="companyTypeChange('reseau')">
                    <span [translate]="'renting.reseau'"> </span>
                  </mat-radio-button>
                  <mat-form-field class="col-lg-6 col-sm-6" id="reseauName">
                    <mat-label>{{'renting.lequel'|translate}}</mat-label>
                    <input matInput #reseauInput (click)="enseigneInput.value = ''" (change)="setDataCompanyName(reseauInput.value, 'reseau');enseigneInput.value = '' " [disabled]="isInputDisabled">
                  </mat-form-field>
                </li>
                <li class="row">
                  <mat-radio-button class="mt-1col-lg-6  col-sm-6 enseigneCheckbox" value="enseigne" (change)="companyTypeChange('enseigne')">
                    <span [translate]="'renting.enseigne'"></span>
                  </mat-radio-button>
                  <mat-form-field class="col-lg-6 col-sm-6" id="enseigneName">
                    <mat-label>{{'renting.laquelle'|translate}}</mat-label>
                    <input matInput #enseigneInput (click)="reseauInput.value = ''" (change)="setDataCompanyName(enseigneInput.value, 'enseigne'); reseauInput.value = ''" [disabled]="!isInputDisabled">
                  </mat-form-field>
                </li>
              </ul>
            </mat-radio-group>
          </div>
          <div class="col-lg-6 col-sm-12">
            <div [formGroup]="rentingForm" class="row">
                <div class="flex flex-column flex-grow-1">
                    <mat-form-field style="padding-left: 15px; padding-right: 15px">
                        <mat-label>{{'renting.customerIxellNumber'|translate}}</mat-label>
                        <input matInput formControlName="ixellAccount">
                    </mat-form-field>
                </div>
                <div class="flex flex-column">
                    <div>
                        <mat-radio-group class="col-lg-3 col-sm-12" formControlName="customerStatus" (click)="removeCheckboxError('tarif')">
                            <span class="mb-2 font-weight-bold" id="tarif">  <span [translate]="'renting.tarif'"> </span> * : </span>
                            <mat-radio-button class="mr-2 mt-4" value="R1">
                                <span> R1 </span>
                            </mat-radio-button>
                            <mat-radio-button class="mr-2 mt-4" value="R2">
                                <span> R2 </span>
                            </mat-radio-button>
                            <mat-radio-button class="mr-2 mt-4" value="R3">
                                <span> R3 </span>
                            </mat-radio-button>
                        </mat-radio-group>
                    </div>
                    <mat-radio-group class="col-lg-12 col-sm-12" formControlName="technology" (click)="removeCheckboxError('technology')">
                        <span class="mb-2 font-weight-bold" id="technology"> <span [translate]="'common.technology'"> </span> * : </span>
                        <mat-radio-button class="mr-2 mt-3" value="Oxelia">
                            <span> Oxelia </span>
                        </mat-radio-button>
                        <mat-radio-button class="mr-2 mt-3" value="Ixelltech">
                            <span> Ixelltech </span>
                        </mat-radio-button>
                        <mat-radio-button class="mr-2 mt-3" value="Equinox">
                            <span> Equinox </span>
                        </mat-radio-button>
                    </mat-radio-group>
                </div>
            </div>
          </div>
        </div>
        <div class="butons">
          <button class="btn btn-secondary" (click)="checkboxError()" matStepperNext>  <span [translate]="'scaleform.suivant'"> </span></button>
        </div>
      </form>
    </mat-step>
    <mat-step>
      <form>
        <ng-template matStepLabel> <span class="respLabel" [translate]="'renting.optionalAccesories'"></span> </ng-template>
        <h1 class="text-center" [translate]="'renting.optionalAccesories'"></h1>
        <hr class="col-10 mx-auto">
        <div class="row">
          <div class="col-lg-6 col-sm-12 accessoireTblCtn">
            <p id="supportTitle">{{'renting.supportselect'|translate}} </p>
            <table class="table table-bordered bg-light respTable">
              <caption></caption>
              <thead>
                <tr>
                  <th scope="col"></th>
                  <th scope="col" class="thImg"></th>
                  <th scope="col" class="text-center">Prix</th>
                  <th scope="col" class="text-center"><span [translate]="'shoppingcart.quantite'"> </span> </th>
                </tr>
              </thead>
              <tbody>
                <!-- Support de base par défaut -->
                <tr>
                  <th scope="col"> <span [translate]="'renting.baseSupport'"></span></th>
                  <td class="text-center tdImg">  <img id="imageSupportBasePro" src="assets/product/SupportBasePro.png" alt="" />  </td>
                  <td class="text-center text-nowrap"> 0 €</td>
                  <td class="text-center text-nowrap">
                    <button class="chevron pointer" [style.visibility]="(supportBaseQty > 0) ? null : 'hidden'"><i aria-hidden="true" class="fa fa-chevron-left"></i></button>
                    <span> {{supportBaseQty}} </span>
                    <button class="chevron pointer" (click)="addProduct('supportBase')" [style.visibility]="(supportBaseQty > 0) ? 'hidden' : null"><i aria-hidden="true" class="fa fa-chevron-right"></i></button>
                  </td>
                </tr>
                <tr *ngFor="let product of products">
                  <th scope="col" *ngIf="product.typeP == 2 && product.fraisLivRentable == 0">
                    <div [ngSwitch]="langue">
                      <div *ngSwitchCase="'fr'">
                        {{product.labelP}}
                      </div>
                      <div *ngSwitchCase="'en'">
                        {{product.labelENP}}
                      </div>
                      <div *ngSwitchCase="'de'">
                        {{product.labelDEP}}
                      </div>
                      <div *ngSwitchCase="'es'">
                        {{product.labelESP}}
                      </div>
                      <div *ngSwitchCase="'it'">
                        {{product.labelITP}}
                      </div>
                      <div *ngSwitchCase="'nl'">
                        {{product.labelNLP}}
                      </div>
                      <div *ngSwitchCase="'ro'">
                        {{product.labelROP}}
                      </div>
                      <div *ngSwitchCase="'pt'">
                        {{product.labelPTP}}
                      </div>
                      <div *ngSwitchCase="'pl'">
                        {{product.labelPLP}}
                      </div>
                      <div *ngSwitchCase="'tr'">
                        {{product.labelTRP}}
                      </div>
                      <div *ngSwitchDefault>
                        {{product.labelP}}
                      </div>
                    </div>
                  </th>
                  <td *ngIf="product.typeP == 2 && product.fraisLivRentable == 1">
                    <span class="font-weight-bold">
                      <div [ngSwitch]="langue">
                        <div *ngSwitchCase="'fr'">
                          {{product.labelP}}
                        </div>
                        <div *ngSwitchCase="'en'">
                          {{product.labelENP}}
                        </div>
                        <div *ngSwitchCase="'de'">
                          {{product.labelDEP}}
                        </div>
                        <div *ngSwitchCase="'es'">
                          {{product.labelESP}}
                        </div>
                        <div *ngSwitchCase="'it'">
                          {{product.labelITP}}
                        </div>
                        <div *ngSwitchCase="'nl'">
                          {{product.labelNLP}}
                        </div>
                        <div *ngSwitchCase="'ro'">
                          {{product.labelROP}}
                        </div>
                        <div *ngSwitchCase="'pt'">
                          {{product.labelPTP}}
                        </div>
                        <div *ngSwitchCase="'pl'">
                          {{product.labelPLP}}
                        </div>
                        <div *ngSwitchCase="'tr'">
                          {{product.labelTRP}}
                        </div>
                        <div *ngSwitchDefault>
                          {{product.labelP}}
                        </div>
                      </div>
                    </span>
                    + {{'shoppingcart.shippingFees'|translate}}
                  </td>
                  <td *ngIf="product.typeP == 2" class="text-center tdImg"> <img src="data:image/png;base64,{{product.pictureBlob2}}" alt="" />  </td>
                  <td *ngIf="product.typeP == 2" class="text-center text-nowrap"> {{product.amountP}} €</td>
                  <td *ngIf="product.typeP == 2" class="text-center text-nowrap">
                    <button class="chevron pointer" (click)="removeProduct(product.labelP)" [style.visibility]="(product.qte === 0) ? 'hidden' : null"> <i aria-hidden="true" class="fa fa-chevron-left"></i></button>
                    <span> {{product.qte}}  </span>
                    <button class="chevron pointer" (click)="addProduct(product.labelP)" [style.visibility]="(product.qte < 1) ? null : 'hidden'">  <i aria-hidden="true" class="fa fa-chevron-right"></i></button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="col-lg-6 col-sm-12 accessoireTblCtn">
            <table class="table table-bordered bg-light respTable">
              <caption></caption>
              <thead>
                <tr>
                  <th scope="col"></th>
                  <th scope="col" class="text-center">Prix</th>
                  <th scope="col" class="text-center"><span [translate]="'shoppingcart.quantite'"> </span></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let product of products">
                  <!-- <div *ngIf="product.typeP != 2" > -->
                  <th scope="col" *ngIf="product.typeP != 2">
                    <div [ngSwitch]="langue">
                      <div *ngSwitchCase="'fr'">
                        {{product.labelP}}
                      </div>
                      <div *ngSwitchCase="'en'">
                        {{product.labelENP}}
                      </div>
                      <div *ngSwitchCase="'de'">
                        {{product.labelDEP}}
                      </div>
                      <div *ngSwitchCase="'es'">
                        {{product.labelESP}}
                      </div>
                      <div *ngSwitchCase="'it'">
                        {{product.labelITP}}
                      </div>
                      <div *ngSwitchCase="'nl'">
                        {{product.labelNLP}}
                      </div>
                      <div *ngSwitchCase="'ro'">
                        {{product.labelROP}}
                      </div>
                      <div *ngSwitchCase="'pt'">
                        {{product.labelPTP}}
                      </div>
                      <div *ngSwitchCase="'pl'">
                        {{product.labelPLP}}
                      </div>
                      <div *ngSwitchCase="'tr'">
                        {{product.labelTRP}}
                      </div>
                      <div *ngSwitchDefault>
                        {{product.labelP}}
                      </div>
                    </div>
                  </th>
                  <td *ngIf="product.typeP != 2" class="text-center text-nowrap">{{product.amountP.toFixed(2).replace(priceRegex, '')}} €</td>
                  <td *ngIf="product.typeP != 2" class="text-center text-nowrap">
                    <button class="chevron pointer" (click)="removeProduct(product.labelP)" [style.visibility]="(product.qte === 0) ? 'hidden' : null"><i aria-hidden="true" class="fa fa-chevron-left"></i></button>
                    <span> {{product.qte}} </span>
                    <button class="chevron pointer" (click)="addProduct(product.labelP)" [style.visibility]="(product.qteStock === 0 || product.qte < product.qteStock) ? null : 'hidden'"><i aria-hidden="true" class="fa fa-chevron-right"></i></button>
                  </td>
                  <!-- </div> -->
                </tr>
                <tr>
                  <td colspan="3"><span class="font-weight-bold" [translate]="'renting.totalAccesories'"></span>{{'stats.common.colon'|translate}}<span class="text-nowrap">{{totalAmount  | number : '1.2-2'}} €</span></td>
                </tr>
              </tbody>
            </table>
          </div>
          <button class="btn btn-secondary btnAccesory" matStepperNext><span [translate]="'scaleform.suivant'"> </span></button>
        </div>
      </form>
    </mat-step>
    <mat-step [stepControl]="finalForm">
      <ng-template matStepLabel> <span class="respLabel" [translate]="'renting.finalInformations'"></span></ng-template>
      <h1 class="text-center" [translate]="'renting.finalInformations'"></h1>
      <hr class="col-10 mx-auto">
      <div class="row">
        <div class="col-lg-6 col-sm-12">
          <h3> <i  aria-hidden="true" class="fal fa-user-hard-hat fa-1-2x titleIcon"></i> <span [translate]="'renting.infoCt'"></span></h3>
          <div [formGroup]="finalForm" class="row">
            <mat-form-field class="col-lg-6 col-sm-12">
              <mat-label>{{'renting.ctIxell'|translate}}</mat-label>
              <input matInput value="{{ct}}" disabled>
            </mat-form-field>
            <mat-form-field class="col-lg-6 col-sm-12">
              <mat-label>{{'renting.ctPhone'|translate}}</mat-label>
              <input matInput *ngIf="!ctPhone" formControlName="ctPhone">
              <input matInput *ngIf="ctPhone" value="{{ctPhone}}" disabled>
            </mat-form-field>
            <mat-form-field class="col-lg-6 col-sm-12">
              <mat-label>{{'renting.ctMail'|translate}}</mat-label>
              <input matInput value="{{ctMail}}" disabled>
            </mat-form-field>
          </div>
        </div>
        <div [formGroup]="finalForm" class=" col-lg-6 col-sm-12mx-auto text-center commercialOffer">
          <h3> <i  aria-hidden="true" class="fal fa-money-check fa-1-2x titleIcon"></i> <span [translate]="'renting.commercialOffer'"> </span></h3>
          <!-- <p class="text-danger"> Veuillez sélectionner une offre </p> -->
          <div *ngIf="isItaly">
            <span> Pagamento in contanti : 2400€ </span>
          </div>
          <mat-radio-group *ngIf="!isItaly" class="comercialOffer" formControlName="rentingDuration" (click)="removerDurationError()">
            <div id="3years">
              <!--<mat-radio-button value="3">
                <span [translate]="'renting.3yearsduration'"></span>
              </mat-radio-button>-->
            </div>
            <div id="5years">
              <mat-radio-button value="5">
                <span [translate]="'renting.5yearsduration'"></span>
              </mat-radio-button>
            </div>
          </mat-radio-group>
        </div>
      </div>
      <div class="text-center">
        <!--<p *ngIf="invalidForm" class="text-danger" [translate]="'renting.formError'"></p>-->
        <!-- <button class="btn btn-secondary" (click)="stepper.reset()"> Envoyer </button> -->
        <button class="btn btn-secondary" (click)="sendData()"> <span [translate]="'scaleform.envoyer'"> </span> </button>
      </div>
    </mat-step>
  </mat-horizontal-stepper>

  <div id="finalModal" class="modal">
    <div class="modal-content">
      <span class="text-right mr-2 pointer close" (click)="closeModal();"> <i  aria-hidden="true" class="fal fa-times fa-1x5 primaryRed"></i> </span>
      <div class="container">
        <i  aria-hidden="true" class="fal fa-clipboard-check iconBackground"></i>
        <div class="upperText">
          <h2 class="text-center" [translate]="'renting.requestOkTitle'"></h2>
          <div class="row">
            <div class="col-lg-8 col-md-10 col-sm-12 mx-auto modalFin p-4">
              <p [translate]="'renting.requestOkInfo'"></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
